const MINUTE = 60000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const RETENTION = 7 * DAY;
const STORAGE_KEY = 'MIRAI:TRUST:V1';
const MAX_RECORDS = 100;
const MAX_STORAGE_SIZE = 131072;

const TRUST_EVENTS = {
  CHANGED: 'trustChanged',
  EVALUATED: 'checkoutTrustEvaluated',
};

const DEFAULT_CONFIG = { contactSignals: false, trustedScore: 60 };

export { DAY, DEFAULT_CONFIG, HOUR, MAX_RECORDS, MAX_STORAGE_SIZE, MINUTE, RETENTION, STORAGE_KEY, TRUST_EVENTS };
